import defer from '../utils/defer';
import { HTTP_CONSTANTS } from '../constants';
/**
 * @ngdoc service
 * @name proximus.core.entity:LocalEntityStore
 * @description
 * # LocalEntityStore
 *  Provides common functions to manage entities in framework
 */
export default class LocalEntityStore {
    constructor(configurationService, encryptionService, storage) {
        this.configurationService = configurationService;
        this.encryptionService = encryptionService;
        this.storage = storage;
    }
    getEntity(entityConfig) {
        const deferred = defer();
        this.storage
            .getItem(entityConfig.uniqueKey, entityConfig.storageStrategy)
            .then((entity) => {
            if (!!entityConfig.expiresIn &&
                entity.fetchedOn &&
                entity.fetchedOn + entityConfig.expiresIn * 1000 < Date.now()) {
                deferred.reject('cached entity has expired (expirated since ' +
                    new Date(entity.fetchedOn + entityConfig.expiresIn * 1000) +
                    ')');
            }
            else if (entity.secure) {
                this.storage
                    .getItem(HTTP_CONSTANTS.X_APPLICATION_ENCRYPTION_KEY_HEADER, entityConfig.storageStrategy)
                    .then(encryptionKey => {
                    //TODO: check this cast
                    entity.value = JSON.parse(this.encryptionService.decryptCypherText(entity.value, encryptionKey));
                    deferred.resolve(entity);
                })
                    .catch(error => {
                    deferred.reject('error getting encryption header from session to decode secured entity from cache' +
                        entityConfig.uniqueKey, error === null || error === void 0 ? void 0 : error.message);
                });
            }
            else {
                deferred.resolve(entity);
            }
        })
            .catch(error => {
            deferred.reject('error getting entity from ' + entityConfig.storageStrategy, error === null || error === void 0 ? void 0 : error.message);
        });
        return deferred.promise;
    }
    saveEntity(entity) {
        const deferred = defer();
        const entityToSave = Object.assign({}, entity);
        this.saveEntityJwts(entityToSave)
            .then(() => {
            if (entity.secure) {
                this.storage
                    .getItem(HTTP_CONSTANTS.X_APPLICATION_ENCRYPTION_KEY_HEADER, entity.storageStrategy)
                    .then(encryptionKey => {
                    entityToSave.value = this.encryptionService.encryptPlainText(JSON.stringify(entityToSave.value), encryptionKey);
                    this.storage.setItem(entity.uniqueKey, entityToSave, entity.storageStrategy).then(() => {
                        deferred.resolve(entity);
                    }, error => {
                        deferred.reject('error saving entity to ' + entity.storageStrategy);
                    });
                })
                    .catch(error => {
                    deferred.reject('error getting encryption header from session');
                });
            }
            else {
                this.storage
                    .setItem(entity.uniqueKey, entityToSave, entity.storageStrategy)
                    .then(() => {
                    deferred.resolve(entity);
                })
                    .catch(error => {
                    deferred.reject('error saving entity to ' + entity.storageStrategy);
                });
            }
        })
            .catch(error => {
            console.error('Could not save entity JWTs:', error);
        });
        return deferred.promise;
    }
    deleteEntity(entity) {
        return this.storage.removeItem(entity.uniqueKey, entity.storageStrategy);
    }
    /////////////
    // Note: entityJwts are now stored with the same strategy as the entity
    saveEntityJwts(entity) {
        const promises = [];
        Object.keys(entity.headers).forEach(key => {
            const headerValue = entity.headers[key];
            if (key.startsWith('x-application-')) {
                if (entity.uniqueJwts && entity.uniqueJwts.indexOf(key) > -1) {
                    key = key + entity.identifier;
                }
                promises.push(this.storage.setItem(key, headerValue, this.configurationService.getJwtStorageStrategy()));
            }
        });
        return Promise.all(promises);
    }
}
